<div class="flx-modal" role="dialog" aria-modal="true">
  <div class="flx-modal__header">
    <div class="with-desc">
      <div class="mp-su-title-row">
        <h2>Suggested {{ translate?.setup.users.users.label.plural }}</h2>
        <span class="mp-su-assignee-pill" *ngIf="data?.joInfo?.orderOwner">
          <i class="fa-regular fa-user"></i>
          Assigned to <strong>{{ data?.joInfo?.orderOwner?.name }}</strong>
        </span>
      </div>
      <div class="sub">
        Executed by rule
        <a
          *ngIf="suggestedAssignUsersInfo?.ruleId"
          class="mp-workflow-link"
          href="javascript:void(0)"
          (click)="viewAssignmentRule()"
          >{{ ruleName }}
          <i class="fa-regular fa-arrow-up-right-from-square"></i>
        </a>
      </div>
    </div>

    <div class="mp-su-header-actions">
      <p-button
        *ngIf="suggestedUsers.length"
        type="button"
        label="Assign Someone Else"
        styleClass="h-28"
        (click)="onAssignSomeoneElse()"
      ></p-button>
      <button
        class="icon-btn"
        [pTooltip]="'Close'"
        tooltipPosition="right"
        (click)="onCancelClick()"
      >
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>
  </div>

  <div class="flx-modal__body">
    <div class="field-wrapper mp-su-top-row">
      <div class="mp-subpanel">
        <div class="mp-sub-body status-field">
          <span class="field-title">Scheduled</span>
          <!-- <span class="field-label">{{ suggestedAssignUsersInfo?.scheduledStart | momentDate : 'EEE, d MMM · HH:mm' : timezone}} - {{suggestedAssignUsersInfo?.scheduledEnd | momentDate : 'EEE, d MMM · HH:mm' : timezone}}</span> -->
          <span class="field-label">
            <strong class="font-medium">
              {{ startTime | momentDate: "hh:mm a" : timezone }}
            </strong>

            <!-- Logic: End Time in Same Day -->
            <ng-container
              *ngIf="
                isSameDay(
                  suggestedAssignUsersInfo?.scheduledStart,
                  suggestedAssignUsersInfo?.scheduledEnd,
                  timezone
                );
                else differentDates
              "
            >
              -
              <strong class="font-medium">
                {{ endTime | momentDate: "hh:mm a" : timezone }} </strong
              >,
              <strong class="font-medium">
                {{ endTime | momentDate: dateFormat : timezone }}
              </strong>
            </ng-container>

            <!-- Logic: End Time in Different Day -->
            <ng-template #differentDates>
              ,
              <strong class="font-medium">
                {{
                  suggestedAssignUsersInfo?.scheduledStart
                    | momentDate: dateFormat : timezone
                }}
              </strong>
              -
              <strong class="font-medium">
                {{ endTime | momentDate: "hh:mm a" : timezone }} </strong
              >,
              <strong class="font-medium">
                {{
                  suggestedAssignUsersInfo?.scheduledEnd
                    | momentDate: dateFormat : timezone
                }}
              </strong>
            </ng-template>
          </span>

          <span class="hint" *ngIf="isScheduledStartInFuture"
            >Starts in {{ countdownLabel }}</span
          ><!-- Starts in 1 h 40 min-->
        </div>
      </div>

      <div class="mp-subpanel">
        <div class="mp-sub-body status-field">
          <span class="field-title"
            >Skills required<span *ngIf="skillsRequired.length">
              . Mandatory</span
            ></span
          >
          <div
            class="status-chip-row mp-su-skills-row"
            *ngIf="skillsRequired.length"
          >
            <span
              class="status-chip border-0"
              *ngFor="let skill of visibleSkills"
              [style.background]="
                skill?.colorCode ? skill?.colorCode : '#DDF3DD'
              "
              [style.color]="darkenHexColor(skill?.colorCode, 0.45)"
            >
              <span class="status-chip__text">{{ skill.label }}</span>
            </span>

            <button
              type="button"
              class="status-chip-row__toggle"
              *ngIf="hiddenSkillsCount > 0 || showAllSkills"
              (click)="toggleSkills()"
            >
              {{
                showAllSkills
                  ? translate?.general.buttons.showLess.singular
                  : "+" +
                    hiddenSkillsCount +
                    " " +
                    translate?.general.buttons.more.singular
              }}
            </button>
          </div>
          <div class="field-label" *ngIf="!skillsRequired.length">
            No mandatory skills
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="suggestedUsers.length && dataLoaded; else emptyState">
      <div
        class="mp-subpanel mp-subpanel-su"
        *ngFor="let user of suggestedUsers"
        [class.is-top-pick]="user.rulesPick"
      >
        <div class="mp-sub-body">
          <div class="mp-su-user-row">
            <div class="mp-su-user-row__head">
              <span class="mp-su-rank">#{{ user.rank }}</span>
              <span class="mp-su-avatar">
                <p-avatar
                  [image]="
                    user.imageUrl ? user.imageUrl : 'assets/svg/Avatar.svg'
                  "
                  styleClass="mr-2 mt-2"
                  shape="circle"
                ></p-avatar>
              </span>
              <span class="field-title">{{ user.fullName }}</span>

              <span
                class="status-chip-row mp-su-badge-row"
                *ngIf="user.rulesPick"
              >
                <span class="status-chip status-chip--profile">
                  <span class="status-chip__text">Rule's pick</span>
                </span>
              </span>
            </div>

            <div class="status-field">
              <span class="field-title">Distance</span>
              <span class="field-label">{{ user.formattedDistance }}</span>
              <span class="hint">
                <span
                  class="mp-su-live-dot"
                  *ngIf="user.lastLocationUpdatedAt"
                ></span>
                <span
                  class="mp-su-live-dot mp-su-live-dot--grey"
                  *ngIf="!user.lastLocationUpdatedAt"
                ></span>
                <span *ngIf="user.lastLocationUpdatedAt"
                  >Last updated
                  {{
                    user.lastLocationUpdatedAt
                      | momentDate: "hh:mm a" : timezone
                  }}</span
                >
                <span *ngIf="!user.lastLocationUpdatedAt">
                  {{ user.locationStatus }}</span
                >
                <!-- not available scenario -->
              </span>
            </div>
            <div class="status-field">
              <span class="field-title">Today</span>
              <span class="field-label">{{ user.todaysJobsCount }} jobs</span>
            </div>

            <div class="mp-su-user-row__meta">
              <span class="status-chip-row mp-su-badge-row">
                <span
                  class="status-chip status-chip--current"
                  *ngIf="isCurrentAssignee(user)"
                >
                  <span class="status-chip__text">Current</span>
                </span>
              </span>
              <p-button
                type="button"
                [label]="translate?.general.buttons.assign.singular"
                (onClick)="onAssign(user)"
                *ngIf="user.rulesPick && !isCurrentAssignee(user)"
              ></p-button>
              <button
                class="custella-btn-white"
                (click)="onAssign(user)"
                *ngIf="!user.rulesPick && !isCurrentAssignee(user)"
              >
                {{ translate?.general.buttons.assign.singular }}
              </button>
            </div>
          </div>

          <div class="mp-su-checks">
            <span
              class="mp-su-check"
              *ngFor="let check of user.checks"
              [class.is-warn]="check.state === 'warn'"
            >
              <i
                class="fa-regular"
                [class.fa-check]="check.state === 'ok'"
                [class.fa-triangle-exclamation]="check.state === 'warn'"
              ></i>
              {{ check.label }}
            </span>

            <button
              type="button"
              class="status-chip-row__toggle mp-su-details-toggle"
              (click)="toggleDetails(user)"
            >
              {{ user.showDetails ? "Hide details" : "Show details" }}
              <i
                class="fa-regular"
                [class.fa-chevron-up]="user.showDetails"
                [class.fa-chevron-down]="!user.showDetails"
              ></i>
            </button>
          </div>

          <div class="mp-su-timeline" *ngIf="user.showDetails">
            <div class="mp-su-timeline__track">
              <div
                class="mp-su-timeline__block"
                *ngFor="let slot of user.scheduleSlots"
                [class.is-new]="slot.kind === 'new'"
                [class.is-overlap]="slot.kind === 'overlap'"
                [ngStyle]="blockStyle(slot)"
                [pTooltip]="slotTooltip(slot)"
                [escape]="false"
                tooltipPosition="top"
                tooltipStyleClass="mp-su-slot-tip"
              >
                <span>{{ slot.label }}</span>
              </div>
            </div>
            <div class="mp-su-timeline__axis">
              <span
                *ngFor="let label of axisLabels; let i = index"
                [ngStyle]="axisLabelStyle(label.hour, i)"
                >{{ label.time }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <div class="note mp-su-empty-note" *ngIf="dataLoaded">
        <p>
          No available {{ translate?.setup.users.users.label.plural }} across
          the {{ translate?.setup.users.groups.label.singular | lowercase }} is
          suitable
        </p>
        <p-button
          type="button"
          label="Select a user"
          styleClass="h-28 me-2"
          (click)="onSelectUserFallback()"
        ></p-button>
      </div>
    </ng-template>

    <div class="mp-su-groups">
      <div
        class="mp-subpanel mp-su-group"
        *ngFor="let group of fallbackGroups"
        [ngClass]="group.isActive ? 'is-active' : ''"
      >
        <div class="mp-sub-body">
          <span class="hint"
            >{{ group.order }} · {{ group.tag | uppercase }}</span
          >
          <div class="field-title">{{ group.name }}</div>
        </div>
      </div>
    </div>

    <p *ngIf="fallbackGroups.length" class="hint">
      FieldEx assigns from this
      {{ translate?.setup.users.groups.label.singular | lowercase }} first.
      Fallback {{ translate?.setup.users.groups.label.plural | lowercase }} are
      only tried if no one here is eligible.
    </p>
    <div
      *ngIf="suggestedUsers.length"
      class="d-flex align-items-center mb-2"
      [ngClass]="fallbackGroups.length ? 'mt-3' : ''"
    >
      <div class="p-field-checkbox">
        <p-checkbox
          [binary]="true"
          [(ngModel)]="isAppliedToAllTasks"
        ></p-checkbox>
      </div>
      <span class="text-12 ms-2">Apply to all added Tasks</span>
    </div>
  </div>
</div>
